module.exports = __webpack_public_path__ + "img/SDG-13-EN-INVERTED.b07a4a9b.png";